// extracted by mini-css-extract-plugin
export default {"head":"head--058b913b","menu":"menu--d0b4dcbb","title":"title--18735434","navs":"navs--be057733","search":"search--9199f203"};